import { AgxFileUpload, DocumentTypes, UploadedDocument } from '@urbanx/agx-ui-components';
import { useAppSelector } from 'hooks/useAppSelector';
import { useCampaignFileUploadProps } from 'hooks/useCampaignFileUploadProps';
import { AgxSpacer } from '@urbanx/agx.ui-components2';
import { useNewSelectedContract } from 'hooks/useNewSelectedContract';

interface AttachAsFileProps {
  id: string;
  defaultValue?: UploadedDocument;
  documentType?: DocumentTypes;
  onValueChanged: (value: { id: string; value?: UploadedDocument }) => void;
  validate?: boolean;
}

const AttachAsFile = ({
  id,
  defaultValue,
  documentType,
  onValueChanged,
  validate,
}: AttachAsFileProps) => {
  const { campaignId } = useAppSelector((state) => state.form);
  const contract = useNewSelectedContract();
  const fileUploadProps = useCampaignFileUploadProps({ contractId: contract?.contractId });
  return (
    <AgxSpacer
      direction="vertical"
      fill
      gap={'spacing-xl'}
      padding={{
        top: 'spacing-2xl',
        bottom: 'spacing-2xl',
        left: 'spacing-lg',
        right: 'spacing-lg',
      }}
    >
      <AgxFileUpload
        {...fileUploadProps}
        showRequiredIndicator={false}
        key={`${id}-fileUpload`}
        id={`${id}-fileUpload`}
        documentType={documentType ?? DocumentTypes.Miscellaneous}
        extensions={['pdf']}
        fileData={defaultValue}
        campaignId={campaignId}
        hideLabel
        title="file"
        onValueChanged={({ value }) =>
          onValueChanged({
            id,
            value: value && value.length > 0 ? value[0] : undefined,
          })
        }
        multiple={false}
        required
        validate={validate}
      />
    </AgxSpacer>
  );
};

export default AttachAsFile;
